const LoyaltyType = {
  CUSTOMER: "customer",
  ATTENDANT: "attendant",
  MANAGER: "manager",
};

export default LoyaltyType;
